import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { fulfillmentsService } from '../../services/fulfillmentsService';
import {
  DispatchType,
  type Address,
  type TimeSlot,
} from '../../types/businessTypes';
import type { Operation } from '../../types/operation';

import { buildMockAsapTimeSlot } from './getFulfillmentMethodMocks';

const ASAP_MINUTES_BY_TYPE: Record<DispatchType, number> = {
  [DispatchType.PICKUP]: 20,
  [DispatchType.DELIVERY]: 35,
  [DispatchType.DINE_IN]: 0,
};

const buildFallbackTimeSlots = (): TimeSlot[] => [
  buildMockAsapTimeSlot({
    dispatchType: DispatchType.PICKUP,
    maxTimeOptions: ASAP_MINUTES_BY_TYPE[DispatchType.PICKUP],
  }),
  buildMockAsapTimeSlot({
    dispatchType: DispatchType.DELIVERY,
    maxTimeOptions: ASAP_MINUTES_BY_TYPE[DispatchType.DELIVERY],
  }),
  buildMockAsapTimeSlot({
    dispatchType: DispatchType.DINE_IN,
    maxTimeOptions: ASAP_MINUTES_BY_TYPE[DispatchType.DINE_IN],
  }),
];

export const getTimeSlotsMock = async (
  flowAPI: ControllerFlowAPI,
  operation: Operation,
  deliveryAddress?: Address,
): Promise<TimeSlot[]> => {
  try {
    const timeSlots = await fulfillmentsService.fetchFirstAvailableTimeSlot(
      flowAPI,
      operation.id,
      deliveryAddress,
    );

    if (timeSlots.length > 0) {
      return timeSlots;
    }
  } catch (e) {}

  return buildFallbackTimeSlots();
};

export const getTimeSlotsPerOperationMock = async (
  flowAPI: ControllerFlowAPI,
  operationIds: string[],
  deliveryAddress?: Address,
): Promise<Record<string, TimeSlot[]>> => {
  try {
    const data =
      await fulfillmentsService.fetchFirstAvailableTimeSlotsPerOperation(
        flowAPI,
        operationIds,
        deliveryAddress,
      );

    if (operationIds.every((id) => (data[id]?.length ?? 0) > 0)) {
      return data;
    }
  } catch (e) {}

  const fallback = buildFallbackTimeSlots();

  return Object.fromEntries(operationIds.map((id) => [id, fallback]));
};
